// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleServiceCategories_wrapper__F3L24","listWrap":"ArticleServiceCategories_listWrap__lOU89","list":"ArticleServiceCategories_list__70ed7"};